var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49016 1.23L3.50016 3.11C2.35016 3.54 1.41016 4.9 1.41016 6.12V13.55C1.41016 14.73 2.19016 16.28 3.14016 16.99L7.44016 20.2C8.85016 21.26 11.1702 21.26 12.5802 20.2L16.8802 16.99C17.8302 16.28 18.6102 14.73 18.6102 13.55V6.12C18.6102 4.89 17.6702 3.53 16.5202 3.1L11.5302 1.23C10.6802 0.919998 9.32016 0.919998 8.49016 1.23Z",
    stroke: "#0044EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0498 10.87L8.6598 12.48L12.9598 8.17999",
    stroke: "#0044EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck2);
export default __webpack_public_path__ + "static/media/icon_check_2.0dba4b1c6096b8bb67fbe5768b64a8ca.svg";
export { ForwardRef as ReactComponent };